/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write your haiku — one line each…`)
};

const es_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe tu haiku — una línea por verso…`)
};

const de_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibe dein Haiku — eine Zeile pro Vers…`)
};

const nl_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrijf je haiku — één regel per keer…`)
};

const fr_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écrivez votre haïku — un vers par ligne…`)
};

const it_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi il tuo haiku — una riga per volta…`)
};

const pt_br2_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva seu haiku — uma linha de cada vez…`)
};

const pt_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva o seu haiku — uma linha de cada vez…`)
};

const ja_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俳句を1行ずつ入力してください…`)
};

const zh_syl_haiku_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请逐行输入你的俳句……`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_placeholder", locale)
	if (locale === "en") return en_syl_haiku_placeholder(inputs)
	if (locale === "es") return es_syl_haiku_placeholder(inputs)
	if (locale === "de") return de_syl_haiku_placeholder(inputs)
	if (locale === "nl") return nl_syl_haiku_placeholder(inputs)
	if (locale === "fr") return fr_syl_haiku_placeholder(inputs)
	if (locale === "it") return it_syl_haiku_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_placeholder(inputs)
	if (locale === "pt") return pt_syl_haiku_placeholder(inputs)
	if (locale === "ja") return ja_syl_haiku_placeholder(inputs)
	return zh_syl_haiku_placeholder(inputs)
};